import { useCallback, useMemo } from "react";
import { ActionsMenu } from "../Actions/ActionsMenu";
import { useAccess } from "src/hooks/useAccess.hook";
import { FEATURE } from "src/util/enums";
import deleteFill from "@iconify/icons-eva/trash-2-outline";
import { useMutate } from "src/hooks/useFetch.hook";
import { customerTagsById } from "src/react-query/endPoints";
import { useDispatch } from "react-redux";
import { alertSlice } from "src/store/alert/alert.slice";
import { useParams } from "react-router-dom";

const CustomerTagActionMenu = ({id,refetch,removeTagFn,...rest}) => {
  const dispatch = useDispatch();
  const { id:customerId } = useParams(); 
  const hasDeleteAccess = useAccess(FEATURE.CUSTOMERS, "D");
  const hasUpdateAccess = useAccess(FEATURE.CUSTOMERS, "U");
  const { mutate } = useMutate("customerTags");
  const onDelete = useCallback(()=>{
    if(removeTagFn){
      removeTagFn(id)
      return;
    }
    mutate({
        url:customerTagsById(customerId,id),
        method: "DELETE",
    }, {
        onSuccess: () => {
            dispatch(
                alertSlice.actions.setAlert({
                  open: true,
                  message: "Successfully disassociated user with selected tag",
                  severity: "success",
                })
              )
            refetch();
        }
    }
    );
  },[id,customerId,mutate,refetch,dispatch,removeTagFn])

  const actionList = useMemo(
        () => [    
          {
            id: "delete",
            title: "Remove",
            icon: deleteFill,
            action: onDelete,
            // For existing customers, require both Delete and Update access
            // For new customers (local state, removeTagFn present), always allow removal
            hidden: removeTagFn ? false : (!hasDeleteAccess || !hasUpdateAccess),
          },
        ],
        [hasDeleteAccess, hasUpdateAccess, removeTagFn, onDelete]
      );

  // Hide the 3-dot button entirely if no menu items are visible
  const hasVisibleActions = actionList.some((item) => !item.hidden);
  if (!hasVisibleActions) return null;

  return <ActionsMenu menuList={actionList} />;
}

export default CustomerTagActionMenu